const SPARKLES = [
  { size: 9, top: "9%", left: "16%", dur: "3.2s", delay: "-0.4s" },
  { size: 6, top: "14%", left: "58%", dur: "2.8s", delay: "-1.7s" },
  { size: 12, top: "22%", left: "84%", dur: "4.1s", delay: "-2.3s" },
  { size: 7, top: "31%", left: "8%", dur: "3.6s", delay: "-1.1s" },
  { size: 10, top: "38%", left: "68%", dur: "2.9s", delay: "-0.9s" },
  { size: 6, top: "47%", left: "30%", dur: "4.4s", delay: "-3.0s" },
  { size: 13, top: "55%", left: "90%", dur: "3.8s", delay: "-1.9s" },
  { size: 8, top: "63%", left: "22%", dur: "3.1s", delay: "-2.6s" },
  { size: 6, top: "70%", left: "52%", dur: "2.7s", delay: "-0.2s" },
  { size: 11, top: "76%", left: "78%", dur: "4.5s", delay: "-3.5s" },
  { size: 7, top: "84%", left: "12%", dur: "3.4s", delay: "-1.4s" },
  { size: 9, top: "90%", left: "44%", dur: "3.9s", delay: "-2.1s" },
  { size: 6, top: "35%", left: "46%", dur: "3.0s", delay: "-2.8s" },
  { size: 10, top: "17%", left: "34%", dur: "4.2s", delay: "-0.7s" },
];

export const AmbientBackground = () => (
  <>
    <div className="page-gradient" aria-hidden="true" />
    <div className="gold-orbs" aria-hidden="true">
      <span className="orb" style={{ width: 520, height: 520, top: "4%", left: "3%", "--dx": "7vw", "--dy": "-6vh", animationDuration: "34s" }} />
      <span className="orb" style={{ width: 380, height: 380, top: "26%", left: "70%", "--dx": "-6vw", "--dy": "8vh", animationDuration: "42s", animationDelay: "-12s" }} />
      <span className="orb" style={{ width: 430, height: 430, top: "56%", left: "12%", "--dx": "5vw", "--dy": "7vh", animationDuration: "38s", animationDelay: "-20s" }} />
      <span className="orb" style={{ width: 340, height: 340, top: "78%", left: "62%", "--dx": "-7vw", "--dy": "-5vh", animationDuration: "46s", animationDelay: "-8s" }} />
      <span className="orb" style={{ width: 300, height: 300, top: "42%", left: "38%", "--dx": "4vw", "--dy": "-7vh", animationDuration: "30s", animationDelay: "-16s" }} />
      <span className="orb" style={{ width: 240, height: 240, top: "12%", left: "48%", "--dx": "-5vw", "--dy": "6vh", animationDuration: "36s", animationDelay: "-4s" }} />
      <span className="orb" style={{ width: 280, height: 280, top: "66%", left: "84%", "--dx": "-6vw", "--dy": "-8vh", animationDuration: "40s", animationDelay: "-24s" }} />
      <span className="orb" style={{ width: 260, height: 260, top: "88%", left: "28%", "--dx": "6vw", "--dy": "-4vh", animationDuration: "32s", animationDelay: "-28s" }} />
    </div>
    <div className="gold-sparkles" aria-hidden="true">
      {SPARKLES.map((s) => (
        <span
          key={`${s.top}-${s.left}`}
          className="sparkle"
          style={{
            width: s.size,
            height: s.size,
            top: s.top,
            left: s.left,
            animationDuration: s.dur,
            animationDelay: s.delay,
          }}
        />
      ))}
    </div>
    <div className="noise-overlay" aria-hidden="true" />
  </>
);
